module.exports = __webpack_public_path__ + "static/img/swipe-1-2.ef34675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/swipe-1-2.png
// module id = xs9L
// module chunks = 10